import { useMutation } from "react-query";
import {
  VehiclePremiumRequestParams,
  switchVehicleHullPremiumType,
} from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const switchVehicleHullPremiumTypeFn = async ({
  rowVersion,
  params,
}: {
  rowVersion: string;
  params: VehiclePremiumRequestParams;
}) => {
  return await switchVehicleHullPremiumType(rowVersion, params);
};

export function useSwitchVehicleHullPremiumType() {
  return useMutation(switchVehicleHullPremiumTypeFn, {
    mutationKey: MUTATION_KEYS.switchVehicleHullPremiumType,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
